<template>
  <div class="py-4 container-fluid">
    <div class="mt-4 tag">
      <div class="col-12">
        <div class="card">
          <!-- Card header -->
          <div class="card-header border-bottom">
            <div class="tag d-flex align-items-center">
              <div class="col-6">
                <h5 class="mb-0">Ingatlan Lista</h5>
              </div>
              <div class="col-6 text-end">
                <material-button class="float-right btn btm-sm" @click="this.$router.push({ name: 'Add RealEstate' })">
                  <i class="fas fa-tag me-2"></i>
                  Ingatlan Hozzáadása
                </material-button>
              </div>
            </div>
          </div>

          <!-- Card body -->
          <div class="px-0 pb-0 card-body">

            <div class="table-responsive p-4">
              <!-- Table -->
              <DataTable id="dataTable" :data="data" :columns="columns" :options="dataTableOptions" ref="table"
                class="table table-flush dataTable-table" width="100%">
                <template #action="props">
                  <td class="dt-control" :text="`Col 1: ${props.cellData}`" @click="rowClick"></td>
                </template>
              </DataTable>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import $ from "jquery";
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net-bs5';
import eventTable from "@/mixins/eventTable.js";
import store from "@/store";
import _ from "lodash";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import BasePagination from "@/components/BasePagination.vue";
import { emptyTableContent, pagination } from "../../../consts";
import router from "@/router"

DataTable.use(DataTablesCore);

var sortDirection = "created_at";

const getRealestatesList = _.debounce(async function (params) {
  await store.dispatch("realestates/getRealEstates");
}, 300);

export default {
  name: "RealEstatesList",
  components: {
    MaterialButton,
    MaterialInput,
    BasePagination,
    DataTable
  },
  mixins: [eventTable],
  setup() {
    const data = ref([]);
    const table = ref();
    const columns = [
      {
        //data: null,
        //className: 'dt-control',
        render: {
          //_: 'pod',
          display: '#action'
        },
      },
      { title: 'Név' },
      { title: 'Cím' },
      { title: 'Tulajdonos' },
      { title: 'Ingatlankezelő' },
      { title: 'Műveletek', class: 'operations-column' },
    ];

    const dataTableOptions = ref(pagination);

    return {
      columns,
      dataTableOptions,
      data,
      table,
    }
  },
  data() {
    return {
      search: "",
      owner: "",
      numberList: "",
      buildingList: "",
      dataRealEstates: [],
      pagination: {},
      dataTable: null,
      keys: null,
      areas: [],
    };
  },
  computed: {
    realestatesList() {
      return this.$store.getters["realestates/getRealEstatesData"];
    },
    metaPage() {
      return this.$store.getters["realestates/getRealEstatesMeta"];
    },
    getAreaNumbersList() {
      return this.$store.getters["areanumbers/getAreanumbersData"];
    },
    getBuildingsList() {
      return this.$store.getters["buildings/getBuildingsData"];
    },
    getFunctionsList() {
      return this.$store.getters["afunctions/getFunctionsData"];
    },
    getRentalUtilizationList() {
      return this.$store.getters["rentalutilization/getRentalUtilizationData"];
    },
    getPositionsList() {
      return this.$store.getters["positions/getPositionsData"];
    },
    getownerList() {
      return this.$store.getters["contacts/getContactsBaseData"];
    },
  },
  watch: {
    realestatesList: {
      handler: "reactiveTable",
      immediate: false,
      deep: true,
    },
  },
  async mounted() {
    await getRealestatesList({
      sort: sortDirection,
      query: "",
      //nr: getCurrentPage,
      //perpage: this.dataTable.options.perPage,
    });
    $('#dataTable .dt-empty').html(emptyTableContent);

    await Promise.all([
      this.$store.dispatch("buildings/getBuildings"),
      this.$store.dispatch("afunctions/getFunctions"),
      this.$store.dispatch("rentalutilization/getRentalUtilization"),
      this.$store.dispatch("positions/getPositions"),
      this.$store.dispatch("areanumbers/getAreanumbers"),
      this.$store.dispatch("contacts/getContactsBaseData"),
    ]);
  },
  beforeUnmount() {
    sortDirection = "created_at";
  },
  methods: {
    calculateRentableUnits(areas) {
      if (!areas) return 0;
      return areas.filter(area => {
        const rentalUtilization = this.getRentalUtilizationList.find(ru => String(ru.id) === String(area.rental_utilization_id));
        return rentalUtilization && rentalUtilization.type === "rentable";
      }).length;
    },
    calculateCommonArea(areas) {
      if (!areas) return 0;
      return areas.reduce((sum, area) => {
        const rentalUtilization = this.getRentalUtilizationList.find(ru => String(ru.id) === String(area.rental_utilization_id));
        if (rentalUtilization && rentalUtilization.type === "public") {
          return sum + (parseFloat(area.net_floor_space) || 0);
        }
        return sum;
      }, 0);
    },
    calculateUtilization(realestate) {
      const deedSize = parseFloat(realestate.deed_size) || 0;
      const grossSize = parseFloat(realestate.gross_size) || 0;
      
      if (grossSize === 0) return 0;
      return Math.round((deedSize / grossSize) * 100);
    },
    calculateRentableArea(areas) {
      if (!areas) return 0;
      return areas.reduce((sum, area) => {
        const rentalUtilization = this.getRentalUtilizationList.find(ru => String(ru.id) === String(area.rental_utilization_id));
        if (rentalUtilization && rentalUtilization.type === "rentable") {
          return sum + (parseFloat(area.net_floor_space) || 0);
        }
        return sum;
      }, 0);
    },
    calculateOperationalArea(areas) {
      if (!areas) return 0;
      return areas.reduce((sum, area) => {
        const rentalUtilization = this.getRentalUtilizationList.find(ru => String(ru.id) === String(area.rental_utilization_id));
        if (rentalUtilization && rentalUtilization.type === "maintenance") {
          return sum + (parseFloat(area.net_floor_space) || 0);
        }
        return sum;
      }, 0);
    },
    calculateProcessingRate(realestate, areas) {
      if (!areas) return 0;
    
      const filledArea = areas.reduce((sum, area) => {
        return sum + (parseFloat(area.gross_floor_space) || 0);
      }, 0);
      
      const grossSize = parseFloat(realestate.gross_size) || 0;
      
      if (grossSize === 0) return 0;
      return Math.round((filledArea / grossSize) * 100);
    },
    formatArea(value) {
      return `${value} m2`;
    },
    formatPercentage(value) {
      return `${value}%`;
    },
    formatDate(date) {
      if (!date) return '';
      return new Date(date).toLocaleDateString('hu-HU');
    },
    
    rowClick(event) {
      const table = $("#dataTable").DataTable();
      let tr = event.target.closest('tr');
      let row = table.row(tr);

      if (row.child.isShown()) {
        row.child.hide();
      } else {
        row.child(this.format(row.data())).show();
      }
    },

    format(d) {
      // `d` is the original data object for the row
      let areaHtml = "";
      
      const realestate = this.realestatesList.find(re => re.name === d[1]);
      const areas = realestate ? realestate.get_areas : [];
      const rentableUnits = this.calculateRentableUnits(areas);
      const commonArea = this.calculateCommonArea(areas);
      const buildingArea = parseFloat(realestate?.gross_size) || 0;
      const utilization = this.calculateUtilization(realestate);
      const rentableArea = this.calculateRentableArea(areas);
      const operationalArea = this.calculateOperationalArea(areas);
      const filledArea = areas.reduce((sum, area) => {
        return sum + (parseFloat(area.gross_floor_space) || 0);
      }, 0);
      
      const processingRate = this.calculateProcessingRate(realestate, areas);
      const renovationDate = realestate?.reconstruction ? realestate.reconstruction + ' [ÁTÉPÍTÉS]' : '-';

      areaHtml += '<div class="info-rows mb-3">';
      areaHtml += '<table class="table table-bordered" style="background-color: #d6e4f0;">';
      areaHtml += '<tr>';
      areaHtml += `<td class="text-center"><strong>${realestate?.name}</strong></td>`;
      areaHtml += `<td class="text-center">${rentableUnits} DB [ BÉRBEADHATÓ EGYSÉG ]</td>`;
      areaHtml += `<td class="text-center">${this.formatArea(commonArea)} [ KÖZÖS TERÜLET ]</td>`;
      areaHtml += `<td class="text-center">${this.formatArea(buildingArea)} [ ÉPÍTMÉNY TERÜLET ]</td>`;
      areaHtml += `<td class="text-center"><strong>${renovationDate}</strong></td>`;
      areaHtml += '</tr>';
      areaHtml += '<tr>';
      areaHtml += `<td class="text-center">${this.formatPercentage(utilization)} [ HASZNOSÍTHATÓSÁG ]</td>`;
      areaHtml += `<td class="text-center">${this.formatArea(rentableArea)} [ BÉRBEADHATÓ TERÜLET ]</td>`;
      areaHtml += `<td class="text-center">${this.formatArea(operationalArea)} [ ÜZEMELTETÉSI TERÜLET ]</td>`;
      areaHtml += `<td class="text-center">${this.formatArea(filledArea)} [ FELTÖLTÖTT TERÜLET ]</td>`;
      areaHtml += `<td class="text-center">${this.formatPercentage(processingRate)} [ FELDOLGOZOTTSÁG ]</td>`;
      areaHtml += '</tr>';
      areaHtml += '</table>';
      areaHtml += '</div>';

      areaHtml += '<div class="table-responsive">'
      areaHtml += '<table class="table table-bordered w-100">'
      areaHtml += '<thead>'
      areaHtml += '<tr>'
      areaHtml += '<th class="text-center">Bérlemény azonosítás</th>'
      areaHtml += '<th class="text-center">Alapterület</th>'
      areaHtml += '<th class="text-center">Funkció</th>'
      areaHtml += '<th class="text-center">Pozíció</th>'
      areaHtml += '<th class="text-center">Épület</th>'
      areaHtml += '</tr>'
      areaHtml += '</thead>'
      areaHtml += '<tbody>'

      areas.forEach(area => {
        let building = this.getBuildingsList.find(b => String(b.id) === String(area.area_buildings_id));
        let afunction = this.getFunctionsList.find(af => String(af.id) === String(area.area_functions_id));
        let position = this.getPositionsList.find(p => String(p.id) === String(area.area_positions_id));
        let utilization = this.getRentalUtilizationList.find(ru => String(ru.id) === String(area.rental_utilization_id));

        areaHtml += '<tr>'
        areaHtml += `<td class="text-center text-uppercase">${area.identifier || '-'} ${utilization.name || '-'}</td>`;
        areaHtml += `<td class="text-center">${area.net_floor_space} m2</td>`;
        areaHtml += `<td class="text-center">${afunction?.name || '-'}</td>`;
        areaHtml += `<td class="text-center">${position?.name || '-'}</td>`;
        areaHtml += `<td class="text-center">${building?.name || '-'}</td>`;
        areaHtml += '</tr>'
      });

      areaHtml += '</tbody>'
      areaHtml += '</table>'
      areaHtml += '</div>'

      return (
        `<dl>
          <dd>${areaHtml}</dd>
          </dl>`
      );
    },

    async getDataFromPage(page) {
      await getRealestatesList({
        sort: sortDirection,
        query: this.search,
        nr: page,
        perpage: this.dataTable.options.perPage,
      });
    },

    async reactiveTable() {

      const actionItemsEditButton = (roleId, text) => {
        const buttonId = `${roleId}-areas-edit`;
        const actionEdit = `
    <a id="${buttonId}" class="cursor-pointer me-3" data-bs-toggle="tooltip" title="${text}">
      <i class="fas fa-home text-warning"></i>
    </a>`;

        this.$nextTick(() => {
          const button = document.getElementById(buttonId);
          if (button) {
            button.addEventListener("click", () => {
              router.push({
                name: "Edit RealEstate Areas",
                params: { id: roleId },
              });
            });
          }
        });

        return actionEdit;
      };

      this.dataRealEstates = [];
      if (this.realestatesList.length > 0) {
        this.realestatesList.forEach((realestate) => {
          this.dataRealEstates.push([
            realestate.get_areas,
            realestate.name,
            realestate.city + ', ' + realestate.address,
            realestate.owner !== null ? realestate.owner['name'] : '',
            realestate.get_property !== null ? realestate.get_property.name : '',
            //new Date(realestate.created_at).toLocaleString(),
            `<div class="text-end">${actionItemsEditButton(realestate.id, "Helyiségek módosítása") +
            this.actionEditButton(realestate.id, "Ingatlan módosítása") +
            this.actionDeleteButton(realestate.id, "Ingatlan törlése")
            }</div>`,
            realestate.owner,
          ]);
        });

        this.data = this.dataRealEstates;
        this.removeEvent();
        await this.$nextTick();
        this.eventToCall({
          myUserId: null,
          redirectPath: "Edit RealEstate",
          deletePath: "realestates/deleteRealEstate",
          getPath: "realestates/getRealEstates",
          textDelete: "Ingatlan sikeresen törölve!",
          textDefaultData: "realestates",
        });
      } else {
        this.dataTable.setMessage("Nincs a keresési feltételnek megfelelő találat.");
      }
    },
  },
};
</script>
